import parent from '../path';

export default `${parent}/resources`;
